import React from 'react'
import Icon from '../Icon'
import './ui.css'

/**
 * Текстовое поле (в т.ч. поиск, число). Единый вид по дизайн-токенам.
 * @param {string} variant - 'default' | 'search'
 * @param {string} iconName - опционально: имя иконки из Icon (например для поиска)
 */
function Input({ variant = 'default', iconName, className = '', ...props }) {
  const isSearch = variant === 'search'
  const baseClass = 'ui-input' + (isSearch ? ' ui-input-search' : '') + (className ? ` ${className}` : '')

  if (iconName) {
    return (
      <div className="ui-input-wrapper">
        <span className="ui-input-icon" aria-hidden>
          <Icon name={iconName} size={18} />
        </span>
        <input type={props.type || 'text'} className={baseClass} {...props} />
      </div>
    )
  }

  return <input type={props.type || 'text'} className={baseClass} {...props} />
}

export default Input
